import React from 'react';
import { useTranslator, XOR } from '@ianesthesie-kit/core';
import { Box, Chip, ChipProps, Stack, Typography } from '@mui/material';
import { CloseButton } from '@/components/drawer/components/CloseButton';
import { PatientInfo } from '@/components/drawer/components/PatientInfo';
import { Patient } from '@/modules/surgicalEvent';

export const DrawerTitle = ({ text }: { text: string }) => (
  <Typography color="text.primary" variant="h4" fontWeight="bold" mb={1}>
    {text}
  </Typography>
);

type DrawerHeaderProps = XOR<{ textId: string }, { text: string }> & {
  patient?: Patient;
  chip?: ChipProps | (ChipProps & { id: string })[];
};

export const DrawerHeader = ({
  textId,
  text,
  patient,
  chip
}: DrawerHeaderProps) => {
  const translate = useTranslator();

  return (
    <>
      <CloseButton />
      <Stack gap={1} mb={2}>
        <Stack direction="row" alignItems="baseline" gap={3}>
          <DrawerTitle text={text ?? translate(textId)} />
          {chip && (
            <>
              {Array.isArray(chip) ? (
                <Box display="flex" gap={1} flexWrap="wrap">
                  {chip.map(({ id, ...chipProps }) => (
                    <Chip key={id} {...chipProps} />
                  ))}
                </Box>
              ) : (
                <Chip {...chip} />
              )}
            </>
          )}
        </Stack>
        <PatientInfo patient={patient} />
      </Stack>
    </>
  );
};
